<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar title="生成二维码" left-arrow @click-left="onClickLeft" />
    </div>
    <div v-if="!showemty">
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in CompanyList"
            :key="index"
            :title="item.name"
            clickable
            @click="radioBtn(index, item.wx_id, item.id)"
          >
            <template #right-icon>
              <van-radio :name="index" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-button color="#5B8DF6" round @click.stop="showPopup"
        >生成二维码</van-button
      >
    </div>
    <div v-if="showemty" class="empty">
      <van-empty
        image="https://account.kmmds.top/datainfo_pic/error.png"
        description="暂无预约挂号记录"
      />
    </div>
    <!-- 二维码弹出层 -->
    <van-popup
      v-model="show"
      :style="{ width: '60%', height: '30%' }"
      class="qrcodestr"
    >
      <ProductQrcode :qrcode="qrcodestr" class="popqrcode" />
    </van-popup>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import ProductQrcode from "@/components/ProductQrcode";
export default {
  data() {
    return {
      showemty:false,
      CompanyList: [],
      radio: "1",
      show: false,
      Companyid: "",
      qrcodestr: "",
      wx_id: "",
    };
  },
  components: {
    Nav,
    ProductQrcode,
  },
  mounted() {
    this.queryallquestionnairesurveyinfo();
  },
  methods: {
    async queryallquestionnairesurveyinfo() {
      try {
        this.$showLoad();
        let url = "/gauge/queryallquestionnairesurveyinfo";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.CompanyList = data.data.data.data;
            if (this.CompanyList.length == 0) {
              this.showemty = true;
            } else {
              this.showemty = false;
            }
          }
        );
      } catch (error) {}
    },
    //   显示二维码
    showPopup(Companyid) {
      if (this.radio != 0 && !this.radio) {
        this.$toast.fail("未选中单位");
        return;
      }
      this.show = true;
      this.showcode = true;
    },
    radioBtn(i, a, cid) {
      this.radio = i;
      this.wx_id = a;
      this.qrcodestr = `http://server.kmmds.top/openId/getqrcode?cid=${cid}&state=1001`;
      console.log(this.qrcodestr);
    },
    onClickLeft() {
      this.$router.push("/index");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
}
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar__title {
  color: white;
}
.van-nav-bar__text {
  color: white;
}
.van-nav-bar {
  background-color: #5b8df6;
}
.nav {
  letter-spacing: 5px;
}
.van-nav-bar__left,
.van-nav-bar__right {
  font-size: 25px;
}
.van-cell {
  line-height: 70px;
}
.van-button {
  position: fixed;
  width: 90%;
  left: 5%;
  height: 40px;
  bottom: 15px;
}
.qrcodestr {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
